module.exports = __webpack_public_path__ + "static/media/mestro.60dd6504.jpg";